import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';

import {
  RsaSearchFinalUrlInitModel,
  RsaSearchFinalUrlInitVariables,
  RsaSearchFinalUrlModel,
  RsaSearchFinalUrlVariables,
} from '../../../../../models/google-template/rsa-search-final-url.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import { GenSingleImageUrlInitModel, GenSingleImageUrlInitVariables, GenSingleImageUrlModel, GenSingleImageUrlVariables } from '../../../../../models/google-template/gen-single-image-url.interface';

@Component({
    selector: 'app-gen-single-image-url',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './gen-single-image-url.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './gen-single-image-url.component.scss'
})
export class GenSingleImageUrlComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: GenSingleImageUrlModel = new GenSingleImageUrlInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new GenSingleImageUrlInitVariables()
    }
  }

  //@ placeholders
  linkPlaceholder: string = 'Enter destination URL';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof GenSingleImageUrlVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof GenSingleImageUrlVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
